<template>
    <div>
        <div class="top">
            <div class="topleft">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item :to="{ path: '/home' }">{{$t('home')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{$t('re32')}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
        <div class="cont">
            <div class="listbox">
                <div class="listright" v-loading="loading">
                    <div class="search">
                        <div class="searchleft">
                            <el-form :inline="true" :model="searchform" class="demo-form-inline" @submit.native.prevent >
                                <el-form-item :label="$t('re23')">
                                    <el-select size="small" v-model="searchform.iden" multiple filterable :placeholder="$t('qxz')">
                                        <el-option :label="$t('re24')" value="0"></el-option>
                                        <el-option :label="$t('re25')" value="1"></el-option>
                                        <el-option :label="$t('re26')" value="2"></el-option>
                                        <el-option :label="$t('re27')" value="3"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item :label="$t('type')">
                                <el-select size="small" v-model="searchform.telType" :placeholder="$t('qxz')" style="width:150px">
                                    <el-option :label="$t('buxian')" :value="null"></el-option>
                                    <el-option v-for="item in typeList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.name">
                                    </el-option>
                                </el-select>
                                <el-form-item :label="$t('tel66')" style="margin-left:10px">
                                    <el-select size="small" v-model="searchform.principalId" filterable :placeholder="$t('qxz')" style="width:130px;">
                                        <el-option :label="$t('buxian')" :value="null"></el-option>
                                        <el-option v-for="item in principallist"
                                            :key="item.id"
                                            :label="item.nickName"
                                            :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item :label="$t('createTime')">
                                    <el-date-picker
                                        v-model="value1"
                                        type="daterange"
                                        size="small"
                                        @change="checkdata"
                                        range-separator="至"
                                        value-format="yyyy-MM-dd"
                                        start-placeholder="开始时间"
                                        end-placeholder="结束时间">
                                    </el-date-picker>
                                </el-form-item>
                            </el-form-item>
                                <el-form-item>
                                    <el-button size="small" type="primary" @click="onSubmit">{{$t('query')}}</el-button>
                                    <el-button size="small" type="primary" @click="exportDate">{{$t('tel84')}}</el-button>
                                    <el-button size="small" type="primary" @click="exportActiveUsers">导出活跃用户</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                    <el-table :data="list" 
                        :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}">
                        <el-table-column prop="phone" :label="$t('phone')"></el-table-column>
                        <el-table-column prop="userName" :label="$t('tel66')"></el-table-column>
                        <el-table-column prop="telType" :label="$t('type')"></el-table-column>
                        <el-table-column prop="idenName" :label="$t('re23')">
                            <template slot-scope="scope">
                                <span style="white-space: pre-wrap; display:block; word-break:break-word;">
                                    {{ scope.row.idenName }}
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="createTime" :label="$t('createTime')">
                            <template slot-scope="scope">
                                {{scope.row.createTime|changedate}}
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="page">
                        <app-page :total="total" :current="pageNo" :pageSize="pageSize"
                            @handleCurrentChange="currentchange" @handleSizeChange="handchange"></app-page>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import apiurl from "@/api/public"
    import _api from "@/api/index"
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import {
        LOAD_CHILDREN_OPTIONS
    } from '@riophae/vue-treeselect'
    export default {
        components: {
            Treeselect
        },
        data() {
            var rolesValid = (rule, value, callback) => {
                callback()
            }
            return {
                loading: false,
                list: [],
                searchform:{
                    iden: null,
                    principalId: null,
                    telType: null,
                },
                typeList: [],
                principallist:[],
                total: 1,
                pageNo: 1,
                pageSize: 10,
            }
        },
        created() {
            this.user=JSON.parse(localStorage.getItem("userinfo"))
            this.getList()
            this.getTypeList()
            this.getprincipal()
            this.value1 = this.getNowTime()
        },
        methods: {
            getNowTime() {
                const now = Date.now();
                const startDate = new Date(now); // 7天前
                const endDate = new Date(now + 1 * 86400000);   // 1天后

                // 本地时间格式化函数
                const formatLocalDate = (date) => {
                    return [
                    date.getFullYear(),
                    String(date.getMonth() + 1).padStart(2, '0'),
                    String(date.getDate()).padStart(2, '0')
                    ].join('-');
                };

                return [formatLocalDate(startDate), formatLocalDate(endDate)];
            },
            getStatusType(status) {
                switch(status) {
                case 'efektif':
                    return 'success';
                default:
                    return 'warning';
                }
            },
            getprincipal() {
                _api.get(apiurl.users, {
                    roleId: 5,
                }).then(res => {
                    this.principallist = res.content
                })
            },
            getTypeList() {
                _api.get(apiurl.typeList, {
                }).then(res => {
                    this.typeList = res.data
                })
            },
            getList() {
                const ss = null
                if (this.searchform.iden != null) {
                    this.ss = this.searchform.iden.join(",")
                }
                this.loading = true
                _api.get(apiurl.activityLevel, {
                    page: this.pageNo,
                    size: this.pageSize,
                    iden: this.ss,
                    createTime: this.value1,
                    principalId: this.searchform.principalId,
                    telType: this.searchform.telType,
                }).then(res => {
                    this.loading = false
                    this.list = res.data.list
                    this.total = res.data.total
                })
            },
            exportDate() {
                _api.download(apiurl.exportActivityLevel, {
                    page: this.pageNo,
                    size: 10000,
                    iden: this.searchform.iden,
                    createTime: this.value1,
                    principalId: this.searchform.principalId,
                    telType: this.searchform.telType,
                }).then(res => {
                    let a = document.createElement('a');
                    let blob = new Blob([res], {type: "application/vnd.ms-excel"});
                    let objectUrl = URL.createObjectURL(blob);
                    a.setAttribute("href", objectUrl);
                    a.setAttribute("download", '活跃度数据.xls');
                    a.click();
                })
            },
            exportActiveUsers() {
                _api.download(apiurl.exportActiveUsers, {
                    createTime: this.value1,
                    telType: this.searchform.telType,
                }).then(res => {
                    let a = document.createElement('a');
                    let blob = new Blob([res], {type: "application/vnd.ms-excel"});
                    let objectUrl = URL.createObjectURL(blob);
                    a.setAttribute("href", objectUrl);
                    a.setAttribute("download", '活跃用户.xls');
                    a.click();
                })
            },
            onSubmit() {
                this.pageNo = 1
                this.getList()
            },
            handchange(data) { //分页Size变化
                this.pageSize = data
                this.pageNo = 1
                this.getList()
            },
            currentchange(data) { //当前页变化
                this.pageNo = data
                this.getList()
            },
        }
    }
</script>
<style scoped>
    .lefttop {
        padding: 8px;
    }

    .listbox {
        display: flex;
    }

    .listleft {
        width: 20%;
        border: 1px solid #EBEEF5;
    }

    .listright {
        width: 100%;
        margin-left: 1%;
    }

    .listrighttop {
        padding: 0 10px;
        background: rgb(245, 245, 245);
        height: 40px;
        overflow: hidden;
        line-height: 40px;
        border-bottom: 1px solid #EBEEF5;
    }

    .listrighttop strong {
        float: left;
    }

    .listrighttop span {
        float: right;
    }

    ::v-deep .vue-treeselect__control,
    ::v-deep .vue-treeselect__placeholder,
    ::v-deep .vue-treeselect__single-value {
        height: 30px;
        line-height: 30px;
    }
</style>